import React from 'react';
import VoiceRecorder from './../component/VoiceRecorder';
import UnreviewedSummaries from '../component/UnreviewedSummaries';

const RecordPage = ({ setActiveStep, setPage }) => {
  return (
    <div className="flex md:space-x-4 h-full bg-[#f5f6f6]">
      <UnreviewedSummaries />
      <VoiceRecorder setActiveStep={setActiveStep} setPage={setPage} />
    </div>
  );
};

export default RecordPage;
